import type { Action } from '@ngrx/store';
import type { CoreApiToken } from '../../../shared';
import type { SessionId } from '../../services/auth/auth.interface';

export enum ActionType {
    UPDATE_OAUTH_TOKEN = '[Rosa - AUTH] UPDATE_OAUTH_TOKEN',
    LOGIN_REQUEST = '[Rosa - AUTH] LOGIN',
    LOGIN_SUCCEEDED = '[Rosa - AUTH] LOGIN_SUCCEEDED',
    LOGIN_FAILED = '[Rosa - AUTH] LOGIN_FAILED',
    LOGOUT = '[Rosa - AUTH] LOGOUT',
    SET_IS_CONNECTED_AS = '[Rosa - AUTH] SET_IS_CONNECTED_AS'
}

export class UpdateOauthToken implements Action {
    readonly type = ActionType.UPDATE_OAUTH_TOKEN;
    constructor(
        readonly payload: {
            token: CoreApiToken;
            newSessionId?: SessionId;
        }
    ) {}
}

export class LoginRequest implements Action {
    readonly type = ActionType.LOGIN_REQUEST;
}

export class LoginSucceeded implements Action {
    readonly type = ActionType.LOGIN_SUCCEEDED;
}

export class LoginFailed implements Action {
    readonly type = ActionType.LOGIN_FAILED;
}
export class Logout implements Action {
    readonly type = ActionType.LOGOUT;
}

export class SetIsConnectedAs implements Action {
    readonly type = ActionType.SET_IS_CONNECTED_AS;
    constructor(readonly payload: boolean) {}
}

export type Actions = LoginRequest | Logout | LoginSucceeded | LoginFailed | UpdateOauthToken | SetIsConnectedAs;
